import React from "react";
import _ from "lodash";
import { defaultOptions } from "./particularList";
import { Checkbox, Select, Textarea, TextInput } from "@mantine/core";
import ArrayTable from "./arrayTable";
import TemplateSaveLoadButtons from "./templateSaveLoadButtons";
import ReactJson from "react-json-view";

const DNParticularList = ({ form, name, readonly = false }) => {
  const particulars = _.get(form.values, name) ?? [];

  const rowInitValue = {
    item: "",
    isKey: false,
    printOnDebitNote: false,
  };

  const fields = [
    {
      header: "Particular",
      headerWidth: "20%",
      fieldName: "title",
      component: TextInput,
      props: {
        data: defaultOptions,
        searchable: true,
        clearable: true,
      },
    },
    {
      header: "Detail",
      headerWidth: "40%",
      fieldName: "detail",
      component: Textarea,
      props: {
        minRows: 1,
        autosize: true,
        py: 0,
      },
    },
    {
      header: "Is Key",
      headerWidth: "10%",
      fieldName: "isKey",
      type: "checkbox",
      component: Checkbox,
      props: {
        type: "checkbox",
      },
    },
  ];

  const loadFromTemplate = (template) => {
    form.setFieldValue(name, template.content ?? []);
  };

  return (
    <>
      {/* <ReactJson src={particulars} style={{ background: "white" }} collapsed /> */}

      {!readonly && (
        <TemplateSaveLoadButtons
          form={form}
          name={name}
          templateCategory="Particulars"
          onLoadTemplate={loadFromTemplate}
          currentContent={particulars}
          mb={"sm"}
        />
      )}
      <ArrayTable
        form={form}
        name={name}
        rowInitValue={rowInitValue}
        fields={fields}
        readonly={readonly}
      />
    </>
  );
};

export default DNParticularList;
